export const GIFT_CARD_NUMBER_TRANSLATION_ID = 'giftCardNumber';
